export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7432.90dfa756.jpg";